import { Link } from "react-router-dom";
import {
  CaretRightIcon,
  PencilSimpleIcon,
  TrashIcon,
} from "@phosphor-icons/react";

import { SecondaryButton, DangerButton } from "./Form";

export default function EntityHeader({
  overline,
  title,
  subtitle,
  breadcrumb,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  meta,
  actions,
}) {
  return (
    <div className="mb-6">
      {breadcrumb && breadcrumb.length > 0 && (
        <nav
          className="text-[11px] uppercase tracking-wider text-slate-500 flex flex-wrap items-center gap-1 mb-2 font-medium"
          data-testid="entity-breadcrumb"
        >
          {breadcrumb.map((c, i) => (
            <span key={i} className="flex items-center gap-1">
              {c.to ? (
                <Link
                  to={c.to}
                  className="hover:text-amber-600 transition-colors"
                >
                  {c.label}
                </Link>
              ) : (
                <span className="text-slate-700">{c.label}</span>
              )}
              {i < breadcrumb.length - 1 && (
                <CaretRightIcon size={10} weight="bold" />
              )}
            </span>
          ))}
        </nav>
      )}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          {overline && (
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
              {overline}
            </div>
          )}
          <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900 mt-1">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-slate-600 mt-1">{subtitle}</p>
          )}
          {meta && (
            <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-slate-500 items-center">
              {meta}
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          {actions}
          {canEdit && (
            <SecondaryButton
              onClick={onEdit}
              data-testid="entity-edit-button"
            >
              <PencilSimpleIcon size={14} /> Edit
            </SecondaryButton>
          )}
          {canDelete && (
            <DangerButton
              onClick={onDelete}
              data-testid="entity-delete-button"
            >
              <TrashIcon size={14} /> Delete
            </DangerButton>
          )}
        </div>
      </div>
    </div>
  );
}
